import { useQuery } from 'src/graphql';
import { CURRENT_USER_META_QUERY } from 'src/graphql/currentUserMeta/query';

export default (skip = false) => useQuery(CURRENT_USER_META_QUERY, { skip });
